interface KindRiskItem {
	kindName: string
	riskName: string
}

export function groupByKindAndRisk<T extends KindRiskItem>(items: T[]) {
	const kindMap = new Map<
		string,
		{ kindName: string; total: number; risks: Map<string, number> }
	>()

	for (const item of items) {
		let kind = kindMap.get(item.kindName)
		if (!kind) {
			kind = { kindName: item.kindName, total: 0, risks: new Map() }
			kindMap.set(item.kindName, kind)
		}
		kind.total += 1
		kind.risks.set(item.riskName, (kind.risks.get(item.riskName) ?? 0) + 1)
	}

	return Array.from(kindMap.values())
		.map((kind) => ({
			kindName: kind.kindName,
			total: kind.total,
			risks: Array.from(kind.risks.entries())
				.map(([riskName, count]) => ({ riskName, count }))
				.sort((a, b) => b.count - a.count),
		}))
		.sort((a, b) => b.total - a.total)
}
